import Vue from 'vue'
import Vuex from 'vuex'
import {
    fnApiFetchMonthlyApproval,
}from '../../api/api-applications-salesforce.js'

Vue.use(Vuex)

const actions = {
    MonthlyApproval(context, formMonthlyApproval){
        return new Promise((resolve, reject) => {
            fnApiFetchMonthlyApproval(formMonthlyApproval)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },
}

export default new Vuex.Store({
    namespaced: true,
    actions
})